import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ffc119fe&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./footer.scss?vue&type=style&index=0&id=ffc119fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc119fe",
  null
  
)

export default component.exports